/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputUavCrewMember
 */
export interface OutputUavCrewMember {
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewMember
     */
    crewRole?: string;
    /**
     * 
     * @type {string}
     * @memberof OutputUavCrewMember
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof OutputUavCrewMember
     */
    userId?: number;
}

/**
 * Check if a given object implements the OutputUavCrewMember interface.
 */
export function instanceOfOutputUavCrewMember(value: object): boolean {
    return true;
}

export function OutputUavCrewMemberFromJSON(json: any): OutputUavCrewMember {
    return OutputUavCrewMemberFromJSONTyped(json, false);
}

export function OutputUavCrewMemberFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputUavCrewMember {
    if (json == null) {
        return json;
    }
    return {
        
        'crewRole': json['crewRole'] == null ? undefined : json['crewRole'],
        'name': json['name'] == null ? undefined : json['name'],
        'userId': json['userId'] == null ? undefined : json['userId'],
    };
}

export function OutputUavCrewMemberToJSON(value?: OutputUavCrewMember | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'crewRole': value['crewRole'],
        'name': value['name'],
        'userId': value['userId'],
    };
}

